import { FETCH_FEEDBACKS } from '../constants/ActionTypes'
import { DEFAULT_PER_PAGE } from '../constants/pagination';

const INITIAL_STATE = {
  feedbacks: {
    data: [],
    pagination: {
      total: 0,
      page: 1,
      per_page: DEFAULT_PER_PAGE,
      total_pages: 0
    }
  }
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_FEEDBACKS:
      // APIv2 returns 1-based page (Laravel's currentPage())
      const page = action.payload.page || 1;
      const total = action.payload.total_count || 0;
      const total_pages = action.payload.page_count || 0;

      return {
        ...state,
        feedbacks: {
          data: action.payload.data || [],
          pagination: {
            total,
            page,
            per_page: action.payload.per_page || state.feedbacks.pagination.per_page,
            total_pages
          }
        }
      };
    default:
      return state;
  }
}